module.exports = __webpack_public_path__ + "img/mountain-railway.7fe72663.png";